import {
  Modal,
  ModalContent,
  ModalFooter,
  useToaster
} from "@dealer-center/core-components";
import { usePermissionGroupsForUserAdd } from "@dealer-center/ddc-pages-user-permissions-manager-fetch";
import { SaveAndCancel } from "@dealer-center/core-custom-components";
import { PermissionsSearchBar } from "../Display/PermissionsSearchBar";
import styled from "styled-components";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

interface AddUserToGroupModalProps {
  show: boolean;
  close: () => void;
}

const StyledModalContent = styled(ModalContent)`
  padding: 0;
  height: 20rem;
`;

export const AddUserToGroupModal = ({
  close,
  show
}: AddUserToGroupModalProps) => {
  let { userId } = useParams();
  if (userId === undefined) {
    userId = "undefined";
  }
  const [permissionsList, setPermissionsList] = useState<string[]>([]);
  const handlePermissionsChange = (newPermissions: string[]) => {
    setPermissionsList(newPermissions);
  };
  const { toastError, toastSuccess } = useToaster();
  const { mutate, isError, isSuccess, isPending } =
    usePermissionGroupsForUserAdd(userId);

  useEffect(() => {
    if (isError) {
      toastError("Error adding user to permission group");
      close();
    }
    if (isSuccess) {
      toastSuccess(
        "Success",
        `Added ${userId} to permissionGroups.length  permission groups successfully`
      );
      close();
    }
  }, [isError, isSuccess, close, toastError, toastSuccess, userId]);

  return (
    <Modal
      className="sample-modal-dialog"
      footer={{
        primary: {
          label: "unused"
        },
        footerComponent: (
          <ModalFooter>
            <SaveAndCancel
              analyticsEventName="Add User to Permission Group(s)"
              isSaving={isPending}
              saveButtonText="Add"
              onCancel={close}
              onSave={() => {
                for (const permission of permissionsList) {
                  try {
                    mutate({ userId, permission });
                  } catch (error) {
                    console.error(error);
                    close();
                  }
                }
              }}
            />
          </ModalFooter>
        )
      }}
      header={`Add User to Permission Group`}
      show={show}
      size="large"
      onHide={close}
    >
      <StyledModalContent>
        <PermissionsSearchBar onPermissionsChange={handlePermissionsChange} />
      </StyledModalContent>
    </Modal>
  );
};
